export default __webpack_public_path__ + "media/images/icons_fc/tools3-0e2a83ef8bca7faa9fe87f620fbffb93.png";